"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getChapterHeaderCss = void 0;
const react_style_object_to_css_1 = __importDefault(require("react-style-object-to-css"));
const helpers_1 = require("../helpers");
/**
 * Can contain previewer only styles
 */
const getChapterHeaderCss = (themeProps, isPreviewer = false, isThumbnail = false, prefix) => {
    var _a;
    const { properties: styleProps } = themeProps;
    return `
    

    .${themeProps._id} .${(0, helpers_1.addPrefix)("chapter-number", prefix)} span{
      display: inline-block;
      font-family: ${(0, helpers_1.getFontFamilyName)(styleProps.chapterNo.font, (0, helpers_1.headerStyleToFontVariant)(styleProps.chapterNo.style))};
      font-size: ${styleProps.chapterNo.size}px;
      text-align: ${styleProps.chapterNo.align};
      width: ${styleProps.chapterNo.width}%;
      ${(0, helpers_1.fontStylesToCssProp)(styleProps.chapterNo.style)}
      ${(0, react_style_object_to_css_1.default)(styleProps.chapterNo.extras)}
      ${isThumbnail ? helpers_1.thumbnailCssOverwrites.number() : ""}
    }

    .${themeProps._id} .${(0, helpers_1.addPrefix)("chapter-title", prefix)} h2, .${themeProps._id} .${(0, helpers_1.addPrefix)("epub-toc-title-card", prefix)} h2{
      display: inline-block;
      font-family: ${(0, helpers_1.getFontFamilyName)(styleProps.chapterTitle.font, (0, helpers_1.headerStyleToFontVariant)(styleProps.chapterTitle.style))} !important;
      font-size: ${styleProps.chapterTitle.size}px;
      text-align: ${styleProps.chapterTitle.align}!important;
      width: ${styleProps.chapterTitle.width}%;
      ${(0, helpers_1.fontStylesToCssProp)(styleProps.chapterTitle.style)}
      ${(0, react_style_object_to_css_1.default)(styleProps.chapterTitle.extras)}
      ${isThumbnail ? helpers_1.thumbnailCssOverwrites.title() : ""}
    }

    .${themeProps._id} .${(0, helpers_1.addPrefix)("chapter-title-card", prefix)} .${(0, helpers_1.addPrefix)("chapter-subtitle", prefix)} h3{
      display: inline-block;
      font-family: ${(0, helpers_1.getFontFamilyName)(styleProps.chapterSubtitle.font, (0, helpers_1.headerStyleToFontVariant)(styleProps.chapterSubtitle.style))};
      font-size: ${styleProps.chapterSubtitle.size}px;
      text-align: ${styleProps.chapterSubtitle.align};
      width: ${styleProps.chapterSubtitle.width}%;
      ${(0, helpers_1.fontStylesToCssProp)(styleProps.chapterSubtitle.style)}
      ${(0, react_style_object_to_css_1.default)(styleProps.chapterSubtitle.extras)}
      ${isThumbnail ? helpers_1.thumbnailCssOverwrites.subtitle() : ""}
    }

    .${themeProps._id} header .${(0, helpers_1.addPrefix)("meta", prefix)}{
      font-size: ${4 + 2 * styleProps.header.size}pt;
      font-family: ${styleProps.header.font};
    }

    .${themeProps._id} footer .${(0, helpers_1.addPrefix)("meta", prefix)}{
      font-size: ${4 + 2 * styleProps.footer.size}pt;
      font-family: ${styleProps.footer.font};
    }

    .${themeProps._id} .${(0, helpers_1.addPrefix)("chapter-title-card", prefix)} .left{
      text-align: left;
    }

    .${themeProps._id} .${(0, helpers_1.addPrefix)("chapter-title-card", prefix)} .center{
      text-align: center;
    }

    .${themeProps._id} .${(0, helpers_1.addPrefix)("chapter-title-card", prefix)} .right{
      text-align: right;
    }

    .${themeProps._id} .${(0, helpers_1.addPrefix)("chapter-title-card", prefix)}{
      width: 100%;
      justify-content:center;
    }

    .${themeProps._id} .${(0, helpers_1.addPrefix)("chapter-title-card", prefix)} .${(0, helpers_1.addPrefix)("chp_bg", prefix)}{
      background-color: rgba(255,255,255, ${1 - (0, helpers_1.getNormalizedOpacity)(styleProps.image.opacity)});
      opacity: ${(0, helpers_1.getNormalizedOpacity)(styleProps.image.opacity)};
      position: absolute;
      top: 0;
      right: 0;
      left: 0;
      bottom: 0;
      background-size: cover;
      background-repeat: no-repeat;
    }

    .${themeProps._id} .${(0, helpers_1.addPrefix)("chapter-title-card", prefix)} .${(0, helpers_1.addPrefix)("chapter-title", prefix)} h2{
      opacity: 1 !important;
      word-break: break-word;
    }

    .${themeProps._id} .${(0, helpers_1.addPrefix)("chapter-title-card", prefix)} .${(0, helpers_1.addPrefix)("chapter-number", prefix)}{
      opacity: 1 !important;
      word-break: break-word;
    }

    .${themeProps._id} .${(0, helpers_1.addPrefix)("chapter-subtitle", prefix)} h3{
      opacity: 1 !important;
      word-break: break-word;
    }

    .${themeProps._id} .${(0, helpers_1.addPrefix)("chapter-title-card", prefix)}, .${themeProps._id} .${(0, helpers_1.addPrefix)("title-card", prefix)}, .${themeProps._id} .${(0, helpers_1.addPrefix)("epub-toc-title-card", prefix)}{
      display: flex;
      flex-direction: column;
    }

    .${themeProps._id} .${(0, helpers_1.addPrefix)("chapter-title-card", prefix)}, .${themeProps._id} .${(0, helpers_1.addPrefix)("epub-toc-title-card", prefix)}{
      display: flex;
      position: relative;
      min-height: 15em;
      padding-bottom: 0;
      ${(0, react_style_object_to_css_1.default)((_a = styleProps.titleCardExtras) === null || _a === void 0 ? void 0 : _a.digital)}
      ${isThumbnail ? helpers_1.thumbnailCssOverwrites.titleCard() : ""}
    }

    .${themeProps._id} .${(0, helpers_1.addPrefix)("chp_clr_none", prefix)} img, .${(0, helpers_1.addPrefix)("chp_clr_none", prefix)}{
      filter: grayscale(100%);
      -webkit-filter: grayscale(100%);
      -moz-filter: grayscale(100%);
      -ms-filter: grayscale(100%);
      -o-filter: grayscale(100%);
    }

    .${themeProps._id} .${(0, helpers_1.addPrefix)("chp_clr_all", prefix)} img, .${(0, helpers_1.addPrefix)("chp_clr_all", prefix)}{
      filter: grayscale(0%);
      -webkit-filter: grayscale(0%);
      -moz-filter: grayscale(0%);
      -ms-filter: grayscale(0%);
      -o-filter: grayscale(0%);
    }

    .${themeProps._id} .${(0, helpers_1.addPrefix)("chapter-title-card", prefix)} .${(0, helpers_1.addPrefix)("chp_img", prefix)}{
      order: ${(0, helpers_1.getImagePlacementOrder)(styleProps.image.placement)};
      text-align: ${styleProps.image.alignment};
      padding-top: 0.3em;
      z-index: 10;
      ${isThumbnail ? helpers_1.thumbnailCssOverwrites.imageContainer() : ""}
    }

    .${themeProps._id} .${(0, helpers_1.addPrefix)("chapter-title-card", prefix)} .${(0, helpers_1.addPrefix)("chp_img", prefix)} img{
      width: ${styleProps.image.width}%;
    }

    .${themeProps._id} .${(0, helpers_1.addPrefix)("chapter-number", prefix)}{
      text-align: ${styleProps.chapterNo.align}!important;
      order: 2;
      text-transform: capitalize;
      z-index: 10;
    }

    .${themeProps._id} .${(0, helpers_1.addPrefix)("chapter-title", prefix)}{
      text-align: ${styleProps.chapterTitle.align}!important;
      order: 3;
      z-index: 10;
    }

    .${themeProps._id} .${(0, helpers_1.addPrefix)("chapter-subtitle", prefix)}{
      text-align: ${styleProps.chapterSubtitle.align}!important;
      order: 4;
      z-index: 10;
    }

    .${themeProps._id} .${(0, helpers_1.addPrefix)("chapter-number", prefix)} span, .${themeProps._id} .${(0, helpers_1.addPrefix)("chapter-title", prefix)} h2, .${themeProps._id} .${(0, helpers_1.addPrefix)("epub-toc-title-card", prefix)} h2, .${themeProps._id} .${(0, helpers_1.addPrefix)("chapter-subtitle", prefix)} h3 {
        font-weight: 400;
    }

    .inverted * {
      color: white !important;
    }

    `;
};
exports.getChapterHeaderCss = getChapterHeaderCss;
